import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pia-speaker-form',
  templateUrl: './pia-speaker-form.component.html',
  styleUrls: ['./pia-speaker-form.component.scss'],
})
export class PiaSpeakerFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
